import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby'
import { useGlobalData } from '../../context/globalDataContxt';
import './PosgradoCareerFeedAll.scss';
import { matchMicrositeByCareer } from '../../helpers/matchMicrositeByCareer';
import { CAREERS_ROUTE } from '../../utils/variables/gatsbyNodeVariables'
import { PlaceOutlined } from '@mui/icons-material';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';

const PosgradoCareerFeedAll = ({ title, careerPlacesFilter, careerModalityFilter, careerMicrosite }) => {

  const { careersAll, micrositesAll } = useGlobalData();
  const [ micrositeByCareers, setMicrositeByCareers ] = useState([]); // All microsites with careers 

  useEffect(() => {    
    const matcheMicrositeByCareer = matchMicrositeByCareer({
      micrositesAll: micrositesAll,
      careersAll: careersAll
    })

    setMicrositeByCareers(matcheMicrositeByCareer)
  }, [micrositesAll, careersAll])

  const searchedCareers = filterCareers(micrositeByCareers, careerMicrosite, careerPlacesFilter, careerModalityFilter);
  
  searchedCareers.sort((a, b) => {
    if (a.name === "Salud y Ambiente") return 1; 
    if (b.name === "Salud y Ambiente") return -1;
    return 0;
  });
  
  return (
    <div className="career-feed my-3 my-md-5">
      <div className="career-feed-title my-2">
        {title}
      </div>

      <div className="row d-flex align-items-stretch">
        {(() => {
      
          if (searchedCareers.length === 0 || micrositeByCareers.length === 0) {
            return (
              <h4 className="mt-5 col">
                No se encontraron carreras que coincidan con su búsqueda
              </h4>
            );
          }
      
          return searchedCareers.map((microsite) => {
            return feedCarrerCreator(
              microsite,
              careerModalityFilter
            );
          });
        })()}
      </div>
    </div>
  );
};


const generateCareerLink = (career) => {

  const getTooltipText = (career) => {
    if (career.modality === 'Distancia') {
      return 'A Distancia'
    } else if (career.modality === 'Ambas') {
      return 'Presencial / A Distancia'
    } else if (career.modality === 'Presencial') {
      return 'Presencial'
    } else if (career.modality === 'Hibrido') {
      return 'Híbrido'
    } else {
      return career.modality
    }
  }

  return (
    <Link 
      key={`careerNodesId-${career.id}`} 
      to={`/${CAREERS_ROUTE}/${career.slug}`}
      target='_self'
      className="items-link" 
    >
      <div className='text-content'>
        <div className='textLink'>
          {career.name.toUpperCase()}
        </div>

        <div className="iconContainer"  role="tooltip" aria-label={getTooltipText(career)} >
          {getTooltipText(career)}
        </div>
      </div>

      <div className='d-flex align-items-center'>
        {career.career_places ? 
          <div className='d-flex align-items-center gap-2' style={{minWidth: "141px"}}>
            <PlaceOutlined fontSize="large"/>
            <div className='d-flex flex-column'>
              {career.career_places
                ?.sort((a, b) => a.title.localeCompare(b.title)) // Alphabetical Order
                .map((place) => {
                  return <span className='textLink' key={`place-${place.title}`}>{place.title}</span>
                })
              }
            </div>
          </div>
        :
          <ArrowForwardIosRoundedIcon fontSize="large" className='mr-2'/>
        }
      </div>
    </Link>
  )
}

// Building Feed Propuesta Academica
const feedCarrerCreator = (microsite, careerModalityFilter) => {
  console.log(careerModalityFilter);
  
  return microsite.careers.length > 0 ? (
    <div 
      className={`mb-4 col-12 col-lg-6`} 
      key={`key-feed-career-${microsite.name}`}
    >
      <div className="card h-100 shadow-sm fade-in-image">
        {/* Portada de los Microsites */}
        <Link
          to={`/${microsite.slug}`}
          target="_blank"
          className="disable__link__styles"
        >
          <div
            className="microsite-image w-100 d-flex flex-column align-items-end"
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3)), url("${
                microsite.coverImg
                  ? microsite.coverImg.url
                  : 'https://ucc-uploads-qa.s3.sa-east-1.amazonaws.com/Slides_Generico_horizontal_89b349f7c7_b88c51e1de.jpg'
              }")`
            }}
          >
            <div className="card-body d-flex align-items-end align-self-start">
              <h4 className="card-title fw-bold text-white text-uppercase">
                {microsite.name}
              </h4>
            </div>
            <div
              className="w-100"
              style={{
                backgroundColor: microsite.color,
                height: '8px'
              }}
            ></div>
          </div>
        </Link>

        {/* Listando carreras */}
        <ul className="list-group list-group-flush">
          {microsite.careers.map((career) => {
            return generateCareerLink(career);
          })}
          
          {microsite.name === "Salud y Ambiente" && (
            careerModalityFilter !== "Distancia" && 
              generateCareerLink({
                id: 1000,
                name: "Especialidades Médicas",
                slug: "../propuesta-academica/especialidades-medicas"
              })
          )}
        </ul>
      </div>
    </div>
  ) : null
}



function filterCareers(micrositeWithCareers, micrositeSelected = null, careerPlacesFilter = null, careerModalityFilter = null) {

  console.log(micrositeSelected);
  console.log(careerPlacesFilter);
  console.log(careerModalityFilter);

  
  
  return micrositeWithCareers.filter((micrositeObj) => {
    // Filtrar por nombre del micrositio si se especifica
    const matchesMicrosite = micrositeSelected ? micrositeObj.name === micrositeSelected.name : true;
    console.log(matchesMicrosite);
    
    if (!matchesMicrosite) return false;

    // Filtrar las carreras de cada micrositio 
    const filteredCareers = micrositeObj.careers?.filter((career) => {

      // Filtramos por lugar (si está definido)
      const matchesPlaces = careerPlacesFilter?.id
        ? career.career_places?.some(place => place.id === careerPlacesFilter.id)
        : true;
    
      // Filtramos por modalidad (si está definida)
      const matchesModality = careerModalityFilter
        ? [
            ...(careerModalityFilter === "Presencial" || careerModalityFilter === "Distancia"
              ? [careerModalityFilter, "Ambas"]
              : [careerModalityFilter]),
          ].includes(career.modality)
        : true;

      return matchesPlaces && matchesModality;
    }) || [];

    // Si el micrositio tiene carreras después del filtro, lo dejamos y actualizamos su lista de carreras
    if (filteredCareers.length > 0) {
      micrositeObj.careers = filteredCareers;
      return true;
    }

    return false;
  });
}

export default PosgradoCareerFeedAll;